import { Component, output, input } from '@angular/core';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

@Component({
  selector: 'empathy-viewer-button',
  templateUrl: 'button.component.html',
  styleUrls: ['./button.component.scss']
})
export class EmpathyViewerButtonComponent {
  color = input<'primary' | 'accent' | 'warn' | 'alert' | 'light' | 'success'>('primary');
  background = input<'transparent' | 'initial'>('initial');
  disabled = input<boolean>(false);
  icon = input<IconDefinition>();
  iconPosition = input<'left' | 'right'>('left');
  loading = input<boolean>(false);
  loadingText = input<string>();
  testId = input<string>();
  text = input<string>();
  tooltip = input<string>();

  clicked = output<void>();
}
